

const routes = [
  // {
  //   path: "/master/satuan",
  //   name: "Satuan",
  //   component: satuan,
  //   meta: {
  //     title: "Data Satuan"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi",
  //   name: "Lokasi",
  //   component: lokasi,
  //   meta: {
  //     title: "Data Lokasi"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/detail/:id",
  //   name: "Lokasi Detail",
  //   component: lokasi_detail,
  //   meta: {
  //     title: "Detail Lokasi"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/edit/:id",
  //   name: "Lokasi Edit",
  //   component: lokasi_adit,
  //   meta: {
  //     title: "Edit Lokasi"
  //   }
  // },
  // {
  //   path: "/master-pembelian/lokasi/add",
  //   name: "Lokasi Add",
  //   component: lokasi_add,
  //   meta: {
  //     title: "Tambah Lokasi"
  //   }
  // }


  
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})